import { featureFlagsStaticData } from 'modules/common/drawers/featureFlagDrawer/const/featureFlags';
import {
  FeatureFlagAvailability,
  FeatureFlagCategory,
  FeatureFlagData,
  FeatureFlagType,
} from 'modules/common/drawers/featureFlagDrawer/types';

export type Tier = 'growth' | 'pro' | 'ent' | 'entMs';

/**
 * Returns array of boolean flag keys where tierInfo[tier].upsell === true, category matches, and availability is CheckEntitlement
 */
export const getUpsellFlagsForTier = (
  tier: Tier,
  category: FeatureFlagCategory,
): string[] => {
  return Object.entries(featureFlagsStaticData)
    .filter(
      ([, flagData]: [string, FeatureFlagData]) =>
        flagData.category === category &&
        flagData.type === FeatureFlagType.Boolean &&
        flagData.availability === FeatureFlagAvailability.CheckEntitlement &&
        flagData.tierInfo[tier].upsell === true,
    )
    .map(([flagKey]) => flagKey);
};

/**
 * Returns the default value for a flag at a given tier
 */
export const getTierDefaultValue = (
  flagData: FeatureFlagData,
  tier: Tier,
): boolean | number | string | undefined => {
  return flagData.tierInfo[tier].default;
};

/**
 * Gets all boolean flag keys for a given category with CheckEntitlement availability
 */
export const getFlagsForCategory = (
  category: FeatureFlagCategory,
): string[] => {
  return Object.entries(featureFlagsStaticData)
    .filter(
      ([, flagData]: [string, FeatureFlagData]) =>
        flagData.category === category &&
        flagData.type === FeatureFlagType.Boolean &&
        flagData.availability === FeatureFlagAvailability.CheckEntitlement,
    )
    .map(([flagKey]) => flagKey);
};
